import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../Img/Icon';

// The row chat/message glyph is the Figma 16×16 bubble (TMS-2332), painted blue via `text-v3-blue`
// (the Icon renders the SVG as a CSS mask + currentColor).
const MESSAGE_ICON = '/img/v3/icons/icon-message-bubble.svg';
const MESSAGE_ICON_SIZE = 16;

class MessageButton extends PureComponent {
    render() {
        const { onMessageClick, 'data-testid': dataTestId } = this.props;
        return (
            <div
                className="click-area click-area-24 text-v3-blue"
                onClick={(ev) => {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onMessageClick();
                }}
                data-testid={dataTestId || undefined}
            >
                <Icon src={MESSAGE_ICON} width={MESSAGE_ICON_SIZE} height={MESSAGE_ICON_SIZE} />
            </div>
        );
    }
}

MessageButton.propTypes = {
    'data-testid': PropTypes.string,
};

MessageButton.defaultProps = {
    'data-testid': null,
};

export default MessageButton;
